import { SiteTypeValue } from '../../core/models/js_env';

export class LargeCommercialPack {
  salesPriceTaxInclude: number | null;
  salesPriceTaxExclude: number | null;

  constructor(salesPriceTaxInclude: string, salesPriceTaxExclude: string) {
    this.salesPriceTaxInclude = this.createinputValue(salesPriceTaxInclude);
    this.salesPriceTaxExclude = this.createinputValue(salesPriceTaxExclude);
  }

  private createinputValue(baseString?: string): number | null {
    let result: number | null;
    if (baseString !== '') {
      result = Number(baseString);
    } else {
      result = null;
    }
    return result;
  }
}

export class CalculateItemSalesPrice {
  companyId?: string;
  departmentId?: string;
  itemList: Array<Item>;

  constructor(companyId: string, departmentId: string, itemList: Array<Item>) {
    if (companyId) {
      this.companyId = companyId;
    }
    if (departmentId) {
      this.departmentId = departmentId;
    }
    this.itemList = itemList;
  }
}

export class Item {
  supplierId: string;
  catalogItemCode: string;
  regularDeliveryItemCode?: string;
  quantity: number;

  constructor(
    supplierId: string,
    catalogItemCode: string,
    regularDeliveryItemCode: string,
    quantity: number
  ) {
    this.supplierId = supplierId;
    this.catalogItemCode = catalogItemCode;
    if (regularDeliveryItemCode) {
      this.regularDeliveryItemCode = regularDeliveryItemCode;
    }
    this.quantity = quantity;
  }
}

export class AsCart {
  totalCount: number;
  totalAmount: number;
  itemImageUrl: string;
  isSameItem: boolean;
  isCartRedirect: boolean;
  redirectPath: string;
  errorCode: string;
  errorMessage: string;

  constructor( // NOSONAR
    totalCount: number,
    totalAmount: number,
    itemImageUrl: string,
    isSameItem: boolean,
    isCartRedirect: boolean,
    redirectPath: string,
    errorCode: string,
    errorMessage: string,
  ) {
    this.totalCount = totalCount;
    this.totalAmount = totalAmount;
    this.itemImageUrl = itemImageUrl;
    this.isSameItem = isSameItem;
    this.isCartRedirect = isCartRedirect;
    this.redirectPath = redirectPath;
    this.errorCode = errorCode;
    this.errorMessage = errorMessage;
  }
}

export class AsCartParameter {
  addCartItemList: AsCartItem[];
  siteType: SiteTypeValue;
  rcmndFldrId: string;

  constructor(itemList: AsCartItem[], siteType: SiteTypeValue, soloelRcmndFldrId: string | null) {
    this.addCartItemList = itemList;
    this.siteType = siteType;
    this.rcmndFldrId = soloelRcmndFldrId || "";
  }
}

export class AsCartItem {
  supplierId: string;
  catalogItemCode: string;
  quantity: number;

  constructor(supplierId: string, catalogItemCode: string, quantity: number) {
    this.supplierId = supplierId;
    this.catalogItemCode = catalogItemCode;
    this.quantity = quantity;
  }
}

export class GetPriceCalculateRequest {
  companyId: string;
  departmentId: string;
  supplierId: string;
  catalogItemCode: string;
  regularDeliveryCatalogItemCode: string;
  quantity: number;

  constructor(
    companyId: string,
    departmentId: string,
    supplierId: string,
    catalogItemCode: string,
    regularDeliveryCatalogItemCode: string,
    quantity: number
  ) {
    this.companyId = companyId;
    this.departmentId = departmentId;
    this.supplierId = supplierId;
    this.catalogItemCode = catalogItemCode;
    this.regularDeliveryCatalogItemCode = regularDeliveryCatalogItemCode;
    this.quantity = quantity;
  }
}

export class GetClickCartButtonRequest {
  supplierId: string;
  catalogItemCode: string;
  quantity: number;
  siteType: string;

  constructor(supplierId: string, catalogItemCode: string, quantity: number, siteType: string) {
    this.supplierId = supplierId;
    this.catalogItemCode = catalogItemCode;
    this.quantity = quantity;
    this.siteType = siteType;
  }
}
